// Diacritic-insensitive ("folded") text for client-side search filters, so a
// picker's local `.includes()` filter matches `Sodiê` when the user types
// `Sodie`.
//
// Mirrors the ClickHouse fold in `firebase/functions/src/shared/search-fold.ts`.
// Use it ONLY for filtering values already held in the browser — never to
// pre-fold a term sent to the backend, which folds the term itself. That keeps
// the two implementations from having to agree byte-for-byte on any comparison.
//
// Two properties are load-bearing:
//
//   1. `toLowerCase()` comes first. The character replacements below list only
//      lowercase forms, so uppercase `Æ` / `Ł` survive otherwise —
//      `Ærø` would fold to `æro`.
//   2. The combining-mark strip is restricted to the Latin block
//      U+0300-U+036F. Thai tone marks and the Japanese dakuten are combining
//      marks too, and stripping them changes meaning. Keeping them and
//      recomposing with NFC makes this a no-op outside Latin, Greek and
//      Cyrillic.
//
// The characters ø ł đ ß æ œ have no canonical decomposition, so NFD leaves
// them intact and they need explicit mapping.

const LATIN_COMBINING_MARKS = /[\u0300-\u036F]/g;

export function foldSearch(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(LATIN_COMBINING_MARKS, '')
    .replace(/ø/g, 'o')
    .replace(/ł/g, 'l')
    .replace(/đ/g, 'd')
    .replace(/ß/g, 'ss')
    .replace(/æ/g, 'ae')
    .replace(/œ/g, 'oe')
    .normalize('NFC')
    .trim();
}
